import axios from 'axios'

type UploadPerimeterProps = {
  url: string
  zipBlob: Uint8Array
}

export async function uploadPerimeter({
  url,
  zipBlob
}: UploadPerimeterProps) {
  await axios.put(url, zipBlob, {
    headers: {
      'Content-Type': 'application/zip'
    }
  })
}
